import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'index',
      component: resolve => require(['@/components/index'],resolve)
    },
    {
      path: '/about',
      name: 'about',
      component: resolve => require(['@/components/about'],resolve)
    },
    {
      path: '/products',
      name: 'products',
      component: resolve => require(['@/components/products'],resolve)
    },
    {
      path: '/contact',
      name: 'contact',
      component: resolve => require(['@/components/contact'],resolve)
    },
    {
      path: '/news',
      name: 'news',
      component: resolve => require(['@/components/news'],resolve)
    },
    {
      path: '/detail',
      name: 'detail',
      component: resolve => require(['@/components/detail'],resolve)
    },
    {
      path: '/proDetail',
      name: 'proDetail',
      component: resolve => require(['@/components/proDetail'],resolve)
    },
    {
      path: '/proDetail1',
      name: 'proDetail1',
      component: resolve => require(['@/components/proDetail1'],resolve)
    },
    {
      path: '/patentDetail',
      name: 'patentDetail',
      component: resolve => require(['@/components/patentDetail'],resolve)
    },
    {
      path: '/mabout',
      name: 'mabout',
      component: resolve => require(['@/components/m_about'],resolve)
    },
    {
      path: '/mproducts',
      name: 'mproducts',
      component: resolve => require(['@/components/m_products'],resolve)
    },
    {
      path: '/mcontact',
      name: 'mcontact',
      component: resolve => require(['@/components/m_contact'],resolve)
    },
    {
      path: '/mcase',
      name: 'mcase',
      component: resolve => require(['@/components/m_case'],resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js